import { render, staticRenderFns } from "./AddOrder.vue?vue&type=template&id=6f040bf4&scoped=true"
import script from "./AddOrder.vue?vue&type=script&lang=js"
export * from "./AddOrder.vue?vue&type=script&lang=js"
import style0 from "./AddOrder.vue?vue&type=style&index=0&id=6f040bf4&prod&lang=scss"
import style1 from "./AddOrder.vue?vue&type=style&index=1&id=6f040bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f040bf4",
  null
  
)

export default component.exports